const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

export default async function getResizeImage(imageSrc, setImage) {
  const image = await createImage(imageSrc);
  let width = image.width;
  let height = image.height;
  let maxLength = height > width ? width : height;
  const limitSize = 1000;

  if (maxLength > limitSize) {
    let percentResize = limitSize / maxLength;
    width = percentResize * image.width;
    height = percentResize * image.height;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
    let newResize = canvas.toDataURL("image/jpeg");
    setImage(newResize);
  } else {
    setImage(imageSrc);
  }
}
